export const LAMBDA = '\u03BB';
export const EPSILON = '\u03B5';


// WEBPACK FOOTER //
// ./src/constants/emptyStringSymbols.js